var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-container",on:{"click":_vm.handleGroupClick}},[_c('div',{staticClass:"group-item"},[_c('avatar',{attrs:{"src":_vm.group.avatar}}),_vm._v(" "),_c('div',{staticClass:"group-name text-ellipsis"},[_vm._v(_vm._s(_vm.group.name))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89157e56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/im/group/group-item.vue
// module id = null
// module chunks = 